import {
  EnvironmentProviders,
  makeEnvironmentProviders,
  Type,
} from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalErrorHandlerHttpInterceptor } from '../interceptors';
import { GlobalErrorDisplayService } from '../services';

export function provideGlobalErrorHandler(
  implementationClass: Type<GlobalErrorDisplayService>,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalErrorHandlerHttpInterceptor,
      multi: true,
    },
    {
      provide: GlobalErrorDisplayService,
      useClass: implementationClass,
    },
  ]);
}
